import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import logo from '../assets/logo.png';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#0f111a',
                color: '#c6a04c',
                py: 4,
                mt: 6,
                textAlign: 'center'
            }}
        >
            <Container maxWidth="lg">
                {/* Logga och namn */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1,
                        mb: 2,
                        flexWrap: 'wrap'
                    }}
                >
                    <img src={logo} alt="Logo" style={{ height: 40 }} />
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        WebbEkonomi & WebbDesign AB
                    </Typography>
                </Box>

                {/* Textrad horisontell och centrerad */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                        fontSize: '0.85rem'
                    }}
                >
                    <Typography variant="body2">Org.nr: 559061-1793</Typography>
                    <Typography
                        variant="body2"
                        component="a"
                        href="/contact?reason=other"
                        sx={{
                            color: '#c6a04c',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            '&:hover': {
                                color: '#fff'
                            }
                        }}
                    >
                        info@webekonomi.se
                    </Typography>

                    <Typography variant="caption">
                        © {new Date().getFullYear()} Alla rättigheter förbehållna.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
